module.exports = __webpack_public_path__ + "static/img/080_TO8_1724_og.8ff6ad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/080_TO8_1724_og.jpg
// module id = SzwY
// module chunks = 0